module.exports = __webpack_public_path__ + "img/img010.99293b6e.png";